import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=1caf18a1"
import script from "./Triangle.vue?vue&type=script&lang=js"
export * from "./Triangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports